(function (app) {

    app.value("speakerList", [
        {
            Name: "Brian Williams",
            Title: "Chief Operating Officer",
            Bio: "As FIG's Chief Operating Officer, Brian oversees the IT department, Compliance, and all business operations of FIG. Brian is also the managing partner of FIG's sister company Alphastar Capital Management.",
            ImgUrl: "/Images/Speakers/williams.jpg"
        },
        {
            Name: "Arron Price",
            Title: "Director of Software Engineering",
            Bio: "Arron came to FIG roughly 6 years ago straight out of college. He has been a key contributor to the FIG Tech Team growing to 4 times its size from when he started and is always ready to cause disruption both in technology and the insurance industry.",
            ImgUrl: "/Images/Speakers/price.jpg"
        },
        {
            Name: "Laura Furner",
            Title: "Senior Business Analyst",
            Bio: "Laura started with FIG as an annuity case manager. After learning what the Tech Team was all about, she joined as a Business Analyst and quickly knew that was where she was meant to be. Using her business knowledge, she has been instrumental in working on many of the new FIG software projects.",
            ImgUrl: "/Images/Speakers/furner.jpg"
        },
        {
            Name: "Lisa Soss",
            Title: "Business Analyst",
            Bio: "Lisa started at FIG in 2013 as an annuity case manager and eventually transitioned over to life case management. For over a year, she has been in a Business Analyst role with the Tech Team and has found something that she is truly passionate about.",
            ImgUrl: "/Images/Speakers/soss.jpg"
        },
        {
            Name: "Andrew Barnett",
            Title: "Senior Software Engineer",
            Bio: "Fresh out of college, Andrew joined the FIG Tech Team as a software developer. He has quickly grown to be seen as a leader both on the Tech Team, as well as when it comes to business decisions within FIG.",
            ImgUrl: "/Images/Speakers/barnett.jpg"
        },
        {
            Name: "David Ferretti",
            Title: "Software Architect",
            Bio: "David is FIG's resident genius and chief architect. He graduated from Georgia Tech in 2012 and has been instrumental in building the tech stack that is FIG's engineering team.",
            ImgUrl: "/Images/Speakers/ferretti.jpg"
        }
    ]);

})(window.app, window.angular); //jshint ignore:line